import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

export default function PilotPrivateCommentsPanel() {
  const { t, i18n } = useTranslation();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loc = i18n.language === 'hu' ? 'hu-HU' : i18n.language === 'he' ? 'he-IL' : 'en-GB';

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.get('/api/pilot-comments/mine');
      setComments(res.data.comments || []);
    } catch (err) {
      setError(err.response?.data?.error || t('pilotProfile.commentsLoadError'));
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => {
    load();
  }, [load]);

  const formatWhen = (c) => {
    if (c.booking_date) {
      const d = new Date(`${c.booking_date}T${String(c.booking_hour || 0).padStart(2, '0')}:00:00`);
      return d.toLocaleString(loc, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
    if (c.created_at) {
      return new Date(c.created_at).toLocaleString(loc);
    }
    return '—';
  };

  return (
    <div className="card pilot-private-comments-panel">
      <h3>{t('pilotProfile.privateCommentsTitle')}</h3>
      <p className="form-hint">{t('pilotProfile.privateCommentsLead')}</p>
      {loading && <p>{t('admin.loading')}</p>}
      {error && <p className="error">{error}</p>}
      {!loading && !error && comments.length === 0 && (
        <p className="admin-muted">{t('pilotProfile.privateCommentsEmpty')}</p>
      )}
      {!loading && comments.length > 0 && (
        <ul className="pilot-private-comments-list">
          {comments.map((c) => (
            <li key={c.id} className="pilot-private-comment-item">
              <div className="pilot-private-comment-meta">
                <strong>{c.author_name}</strong>
                <span>{formatWhen(c)}</span>
              </div>
              <p className="pilot-private-comment-body">{c.comment}</p>
              {c.author_email && (
                <p className="pilot-private-comment-email">
                  <a href={`mailto:${c.author_email}`}>{c.author_email}</a>
                </p>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
